<button mat-raised-button>
  <mat-icon
    style="
      display: flex;
      align-items: center;
      justify-content: center;
    "
    class="cancel-icon"
    svgIcon="{{EsvgFiles.close}}"
  />
</button>
